import { render, staticRenderFns } from "./SyVoteList.vue?vue&type=template&id=30ec336b&scoped=true"
import script from "./SyVoteList.vue?vue&type=script&lang=ts"
export * from "./SyVoteList.vue?vue&type=script&lang=ts"
import style0 from "./SyVoteList.vue?vue&type=style&index=0&id=30ec336b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ec336b",
  null
  
)

export default component.exports